import React, { useState } from 'react'

import { EuiPopover } from '@elastic/eui'

interface AdHoverPreviewProps {
  enabled: boolean
  imageUrl?: string | null
  videoUrl?: string | null
  children: React.ReactElement
}

const previewMaxSize = 480

export const AdHoverPreview: React.FC<AdHoverPreviewProps> = ({ enabled, imageUrl, videoUrl, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const hasMedia = !!videoUrl || !!imageUrl

  if (!enabled || !hasMedia) {
    return children
  }

  const anchor = (
    <div onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} style={{ cursor: 'zoom-in' }}>
      {children}
    </div>
  )

  return (
    <EuiPopover button={anchor} isOpen={isOpen} closePopover={() => setIsOpen(false)} anchorPosition='rightCenter' panelPaddingSize='s' ownFocus={false}>
      {videoUrl ? <video src={videoUrl} autoPlay muted loop playsInline style={{ maxWidth: previewMaxSize, maxHeight: previewMaxSize, display: 'block' }} /> : <img src={imageUrl ?? undefined} alt='ad preview' style={{ maxWidth: previewMaxSize, maxHeight: previewMaxSize, display: 'block' }} />}
    </EuiPopover>
  )
}
